import { Alert } from '@ver-uds/uswds-react';
import React from 'react';
import dateFormat from 'dateformat';
import AriaLink from '../AriaLink/AriaLink';
import LinkType from '../../constants/LinkType';

interface Props {
  // eslint-disable-next-line react/require-default-props
  closedDate?: Date;
}

const TerminationBanner = ({ closedDate }: Props): JSX.Element => {
  const supportEmail = 'E-Verify.support@uscis.dhs.gov';
  const alertHeading = `E-Verify intends to terminate this account for misuse. The scheduled termination date is ${dateFormat(
    closedDate,
    'longDate',
  )}.`;

  return (
    <div className="margin-bottom-3 margin-top-2">
      <Alert status="warning">
        <Alert.Heading>{alertHeading}</Alert.Heading>
        <Alert.Text>
          E-Verify has attempted to contact your organization on several occasions. Email{' '}
          <AriaLink link={supportEmail} linkType={LinkType.EMAIL} customLinkText={supportEmail} /> for assistance.
        </Alert.Text>
      </Alert>
    </div>
  );
};

export default TerminationBanner;
